import { csx } from '@vtex/admin-ui'

const styles = {
  header: csx({
    paddingBottom: 0,
  }),
  title: csx({
    display: 'flex',
    alignItems: 'center',
    gap: '$space-1',
  }),
  icon: csx({
    color: '$warning',
  }),
  continue: csx({
    marginTop: '$space-5',
    display: 'block',
  }),
}

export default styles
